<template>
  <i
    :class="iconClass"
    :style="iconStyle"
  >
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.293 20.707a1 1 0 0 1 0-1.414L14.586 12 7.293 4.707a1 1 0 0 1 1.414-1.414l8 8a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0Z"/></svg>
    <!-- eslint-enable -->
  </i>
</template>

<script>
import BaseIcon from '../BaseIcon.vue';

export default {
  name: 'DpIconCaretRight',
  extends: BaseIcon,
  iconName: 'caret-right',
  iconCategory: 'caret',
};
</script>
